module.exports = __webpack_public_path__ + "img/arrow-next.a5503243.svg";